import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from "react";
import blogData from "./Blog.json";
import "./MyBlog.css";

const MyBlog = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <section data-aos="fade-right" id="blog" className="blog-mf">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="title-box text-center">
              <h3 className="title-a">Blog</h3>
              <div className="line-mf"></div>
            </div>
          </div>
        </div>
        <div className="row">
          {blogData.map((data) => (
            <div className="col-md-4 p-3">
              <div className="card card-blog">
                <div className="card-img">
                  <img src={data.img} alt="" className="img-fluid" />
                </div>
                <div className="card-body">
                  <h3 className="card-title text-center text-warning">
                    {data.blog}
                  </h3>
                  <p className="card-description">{data.blogDetails}</p>
                  <div className="w-more">
                    <a href="#" className="w-ctegory">
                      Read More
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MyBlog;
